<script>
  import {createEventDispatcher} from 'svelte';
  import store from '../../../Stores/tipo-de-jornada-store';
  import storeTipos from '../../../Stores/tipos-de-jornada-store';

  import {validaTipoDeJornada} from '../../../Modelos/TipoDeJornada';

  import Caja from "../../UI/Caja.svelte";
  import Subtitulo from "../../UI/Subtitulo.svelte";
  import Icono from "../Icono.svelte";
  import CampoDeTexto from "../../UI/CampoDeTexto.svelte";
  import CampoDeSeleccion from "../../UI/CampoDeSeleccion.svelte";
  import SeleccionDeColor from "../../UI/SeleccionDeColor.svelte";
  import CampoDeCheckbox from "../../UI/CampoDeCheckbox.svelte";
  import Boton from "../../UI/Boton.svelte";
  import Horario from './Horario.svelte';
  import HorarioFlexible from './HorarioFlexible.svelte';
  import SinHorario from './SinHorario.svelte';
  import Festivo from './Festivo.svelte';
  import Vacaciones from './Vacaciones.svelte';

  const dispatch = createEventDispatcher();

  let tipoDeJornada, error, errores;
  $: tipoDeJornada = $store.tipo;
  $: errores = validaTipoDeJornada(tipoDeJornada);
  $: error = $store.error;

  const tipoValidado = e => {
    errores = Object.keys.reduce((acc, key) => {
      if (key === 'hijo') {
        return {...acc, hijo: e.detail};
      } else {
        return acc;
      }
    }, {});
  };

  let estadoInicial;
  $: estadoInicial = estadoInicial || $store.tipo;

  let sucio = false;
  $: sucio = JSON.stringify(estadoInicial) !== JSON.stringify($store.tipo);

  $: tiposDeJornada = [
    {valor: 'horario', etiqueta: 'Horario fijo'},
    {valor: 'flexible', etiqueta: 'Horario flexible'},
    {valor: 'sin-horario', etiqueta: 'Sin horario'},
    {valor: 'festivo', etiqueta: 'Festivo'},
    {valor: 'vacaciones', etiqueta: 'Vacaciones'},
  ];

  const actualizaCampo = (campo, valor) => store.actualizaCampo(campo, valor);

  const enviaFormulario = e => {
    e.preventDefault();
    estadoInicial = null;
    store.guarda().then(() => storeTipos.cargar().then(() => dispatch('enviado')));
  };

  let tipoDeFormulario = null;
  const formularios = {
    horario: Horario,
    'flexible': HorarioFlexible,
    'sin-horario': SinHorario,
    'festivo': Festivo,
    'vacaciones': Vacaciones,
  };

  $: tipoDeFormulario = formularios[tipoDeJornada.tipo];

  const colores = [
    'rgb(244, 67, 54)',
    'rgb(233, 30, 99)',
    'rgb(156, 39, 176)',
    'rgb(103, 58, 183)',
    'rgb(63, 81, 181)',
    'rgb(33, 150, 243)',
    'rgb(3, 169, 244)',
    'rgb(0, 188, 212)',
    'rgb(0, 150, 136)',
    'rgb(76, 175, 80)',
    'rgb(139, 195, 74)',
    'rgb(205, 220, 57)',
    'rgb(255, 193, 7)',
    'rgb(255, 152, 0)',
    'rgb(255, 87, 34)',
    'rgb(121, 85, 72)',
    'rgb(158, 158, 158)',
    'rgb(96, 125, 139)'
  ];
</script>

<style>
    @media (min-width: 1024px) {
        .fila {
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-gap: var(--padding-global);
        }

        .fila-3 {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            grid-gap: var(--padding-global);
        }

        .fila-2 {
            display: grid;
            grid-template-columns: 2fr 1fr;
            grid-gap: var(--padding-global);
        }
    }
</style>

<Caja>
    <div slot="titulo">
        <Subtitulo>
            <Icono tipo={tipoDeJornada}/>

            {tipoDeJornada.nombre}
        </Subtitulo>
    </div>

    <form on:submit={enviaFormulario}>
        <div class="fila-3">
            <CampoDeTexto id="nombre" label="Nombre" value={tipoDeJornada.nombre}
                          icono="scatter_plot" valido={!errores.nombre}
                          mensajeDeError={errores.nombre} disabled={tipoDeJornada.protegido}
                          on:input={e => actualizaCampo('nombre', e.target.value)}/>

            <CampoDeSeleccion id="tipo" label="Tipo" value={tipoDeJornada.tipo}
                              valido={!errores.tipo} mensajeDeError={errores.tipo}
                              opciones={tiposDeJornada} icono="category"
                              disabled={tipoDeJornada.protegido}
                              on:input={e => actualizaCampo('tipo', e.target.value)}/>

            <div style="display: flex; justify-content: space-between">
                <CampoDeCheckbox id="activo" label="Activo" value={tipoDeJornada.activo}
                                 disabled={tipoDeJornada.protegido}
                                 on:change={e => actualizaCampo('activo', e.detail)}/>

                <CampoDeCheckbox id="nocturna" label="Nocturno" value={tipoDeJornada.nocturna}
                                 on:change={e => actualizaCampo('nocturna', e.detail)}/>

                <CampoDeCheckbox id="entradaEstricta" label="Entrada estricta"
                                 value={tipoDeJornada.entradaEstricta}
                                 on:change={e => actualizaCampo('entradaEstricta', e.detail)}/>

            </div>
        </div>

        <div class="fila-3">
            <CampoDeTexto id="descripcion" label="Descripción" value={tipoDeJornada.descripcion}
                          icono="insert_comment" valido={!errores.descripcion}
                          mensajeDeError={errores.descripcion} disabled={tipoDeJornada.protegido}
                          controlType="textarea" rows="5"
                          on:input={e => actualizaCampo('descripcion', e.target.value)}/>

            <CampoDeTexto type="number" id="descansoObligatorio"
                          label="Descanso obligatorio (minutos)"
                          min="0" value={tipoDeJornada.descansoObligatorio} icono="scatter_plot"
                          valido={!errores.descansoObligatorio}
                          mensajeDeError={errores.descansoObligatorio}
                          on:input={e => actualizaCampo('descansoObligatorio', e.target.value)}/>

            <CampoDeTexto type="number" id="tolerancia" label="Tolerancia (minutos)"
                          value={tipoDeJornada.tolerancia} icono="scatter_plot"
                          valido={!errores.tolerancia}
                          mensajeDeError={errores.tolerancia}
                          on:input={e => actualizaCampo('tolerancia', e.target.value)}/>
        </div>

        <div class="fila-3">
            <SeleccionDeColor {colores} valor={tipoDeJornada.color} label="Color"
                              on:color-seleccionado={e => actualizaCampo('color', e.detail)}/>
        </div>

        <div class="fila">
            <svelte:component this={tipoDeFormulario}
                              tipoDeJornada={tipoDeJornada}
                              on:validado={tipoValidado}/>
        </div>
    </form>

    <div slot="pie">
        <Boton on:click={enviaFormulario} type="submit"
               disabled={!sucio || Object.keys(errores).length}>
            Guardar
        </Boton>
    </div>
</Caja>